/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/A11yRadioGroup',[
    'jquery',
    'global/Logger'
], function ($, Logger) {

    function keyCodes() {
        // Define values for keycodes
        this.enter = 13;
        this.space = 32;

        this.left = 37;
        this.up = 38;
        this.right = 39;
        this.down = 40;
    }

    /**
     * Function radioGroup() is a class to define an ARIA-enabled radiogroup widget.
     *
     * This widget attaches to an unordered list and makes each list entry a group
     * of radio buttons.
     *
     * @param (id object) id is the html id of the <ul> to attach to
     *
     * @return N/A
     */
    function radioGroup(id) {

        var thisObj = this;

        ///////// define widget properties ///////////////

        this.thisObj = thisObj;

        this.$id = $('#' + id).attr('tabindex', 0);

        // find all list items with a role of radio
        this.$buttons = this.$id.find('li').filter('[role=radio]').attr('tabindex', -1);

        // Store the currently checked item
        this.$checked = this.$buttons.filter('[aria-checked=true]');

        this.checkButton = true; // set to false during ctrl+arrow operations;

        if (this.$checked.length > 0) {
            this.$active = $('#' + this.$id.attr('aria-activedescendant')); // the active button
        }
        else {
            this.$active = null; // no selected button
        }

        this.keys = new keyCodes();

        ///////////// Bind Event handlers ////////////////

        this.$buttons.on('click', function (e) {
            return thisObj.handleClick(e, $(this));
        });

        this.$id.on('keydown', function (e) {
            return thisObj.handleKeyDown(e, $(this));
        });

        this.$id.on('keypress', function (e) {
            return thisObj.handleKeyPress(e, $(this));
        });

        this.$id.on('focus', function (e) {
            return thisObj.handleFocus(e, $(this));
        });

        this.$id.on('blur', function (e) {
            return thisObj.handleBlur(e, $(this));
        });
    }

    radioGroup.prototype.exposeEvent = function (eventType, $id) {
        var callback = $.Event('roc' + eventType);
        callback.currentActive = $id;

        this.$id.trigger(callback);

        // if prevent default block execution
        return !callback.isDefaultPrevented();
    }

    //
    // Function selectButton() is a member function to select and possibly check a button in the
    // radioGroup.
    //
    // @param ($id object) $id is the jQuery object of the button to select
    //
    // @return N/A
    //
    radioGroup.prototype.selectButton = function ($id) {
        this.exposeEvent('BeforeSelected', $id);
        if (!this.exposeEvent('BeforeSelected')) {
            return false;
        };

        // if button is disabled, do not select
        if ($id.attr("aria-disabled")) {
            this.exposeEvent('Disabled', $id);
            return true;
        };

        if (this.checkButton === true) {
            // checking the button

            this.exposeEvent('BeforeActive', $id);
            if (!this.exposeEvent('BeforeActive')) {
                return false;
            };

            if (this.$active) {
                // remove the active styling from the previous active button
                this.$active.removeClass('active');
            }

            // give this button the active class
            $id.addClass('active');

            // set the previous button's aria-checked attribute to false
            this.$checked.attr('aria-checked', 'false');

            // set the new button's aria-checked attribute to true
            $id.attr('aria-checked', 'true');

            // update the stored $checked object
            this.$checked = $id;

            this.exposeEvent('AfterActive', $id);
        }

        this.exposeEvent('BeforeSelectedAfterActive', $id);
        if (!this.exposeEvent('BeforeSelectedAfterActive')) {
            return false;
        };


        if (this.$active) {
            // remove the selected styling from the previous active button
            this.$active.removeClass('selected');
        }

        // give this button the selected class
        $id.addClass('selected');

        // update the stored $active object
        this.$active = $id;

        // update the aria-activedescendant property of the group
        this.$id.attr('aria-activedescendant', $id.attr('id'));

        // reset the checkButton flag - in case it was false
        this.checkButton = true;

        this.exposeEvent('AfterSelected', $id);

    } // end selectButton()

    //
    // Function handleClick() is a member function to process keydown events for the radioGroup.
    //
    // @param (e object) e is the event object
    //
    // @param ($id object) $is is the jquery object of the triggering element
    //
    // @return (boolean) Returns false if consuming event; true if propagating
    //
    radioGroup.prototype.handleClick = function (e, $id) {
        if (e.altKey || e.ctrlKey || e.shiftKey) {
            // do nothing
            return true;
        }

        // select the clicked button
        this.selectButton($id);

        // give the group focus
        //this.$id.focus();

        e.stopPropagation();
        return false;

    } // end handleClick()

    //
    // Function handleKeyDown() is a member function to process keydown events for the radioGroup.
    //
    // @param (e object) e is the event object
    //
    // @param ($id object) $is is the jquery object of the triggering element
    //
    // @return (boolean) Returns false if consuming event; true if propagating
    //
    radioGroup.prototype.handleKeyDown = function (e, $id) {

        if (e.altKey) {
            // do nothing
            return true;
        }

        switch (e.keyCode) {
            case this.keys.space:
            case this.keys.enter: {
                if (e.ctrlkey || e.shiftKey) {
                    // do nothing
                    return true;
                }

                // select and check the active the button
                this.selectButton(this.$active);

                e.stopPropagation();
                return false;
            }
            case this.keys.left:
            case this.keys.up: {

                var $prev = this.$active.prevAll(':not([aria-disabled]):first'); // the previous button

                if (e.shiftKey) {
                    // do nothing
                    return true;
                }

                // if this was the first item
                // select the last one in the group.
                if ($prev.length === 0 || this.$active.index() === 0) {
                    $prev = this.$buttons.filter(':not([aria-disabled])').last();
                }

                if (e.ctrlKey) {
                    // set checkButton to false so
                    // focus does not check button
                    this.checkButton = false;
                }

                // select the previous button
                this.selectButton($prev);

                e.stopPropagation();
                return false;
            }
            case this.keys.right:
            case this.keys.down: {

                var $next = this.$active.nextAll(':not([aria-disabled]):eq(0)'); // the next button

                if (e.shiftKey) {
                    // do nothing
                    return true;
                }

                // if this was the last item,
                // select the first one in the group.
                if ($next.length === 0 || this.$active.index() == this.$buttons.length - 1) {
                    $next = this.$buttons.filter(':not([aria-disabled])').first();
                }

                if (e.ctrlKey) {
                    // set checkButton to false so
                    // focus does not check button
                    this.checkButton = false;
                }

                // give the next button focus
                this.selectButton($next);

                e.stopPropagation();
                return false;
            }
        } // end switch

        return true;

    } // end handleKeyDown()

    //
    // Function handleKeyPress() is a member function to process keydown events for the radioGroup.
    // This is needed to prevent browsers that process window events on keypress (such as Opera) from
    // performing unwanted scrolling of the window, etc.
    //
    // @param (e object) e is the event object
    //
    // @param ($id object) $is is the jquery object of the triggering element
    //
    // @return (boolean) Returns false if consuming event; true if propagating
    //
    radioGroup.prototype.handleKeyPress = function (e, $id) {

        if (e.altKey) {
            // do nothing
            return true;
        }

        switch (e.keyCode) {
            case this.keys.space:
            case this.keys.enter: {
                if (e.ctrlKey || e.shiftKey) {
                    // do nothing
                    return true;
                }
            }
            break
            case this.keys.left:
            case this.keys.up:
            case this.keys.right:
            case this.keys.down: {
                if (e.shiftKey) {
                    // do nothing
                    return true;
                }
                e.stopPropagation();
                return false;
            }
            break
        } // end switch

        return true;

    } // end handleKeyPress()

    //
    // Function handleFocus() is a member function to process focus events for the radioGroup.
    //
    // @param (e object) e is the event object
    //
    // @param ($id object) $is is the jquery object of the triggering element
    //
    // @return (boolean) Returns false if consuming event; true if propagating
    //
    radioGroup.prototype.handleFocus = function (e, $id) {
        if (!this.$active) {
            // no previously selected button - select first one
            this.selectButton(this.$buttons.filter(':not([aria-disabled])').first());
        }
        else {
            // select active button
            this.selectButton(this.$active);
        }

        return true;
    } // end handleFocus()

    //
    // Function handleBlur() is a member function to process blur events for the radioGroup.
    //
    // @param (e object) e is the event object
    //
    // @param ($id object) $is is the jquery object of the triggering element
    //
    // @return (boolean) Returns false if consuming event; true if propagating
    //
    radioGroup.prototype.handleBlur = function (e, $id) {

        // remove the focus styling from this buttons
        this.$buttons.removeClass('selected');

        return true;
    } // end handleBlur()

    Logger.debug('A11yRadioGroup.js Loaded:');

    return radioGroup;
});
